/**
 * Hook para gestión de permisos de Odoo Migration
 * Migrado a usar el hook centralizado usePermissions
 *
 * @deprecated Usar import { useOdooMigrationPermissions } from './usePermissions' directamente
 */
import { useOdooMigrationPermissions as usePermissionsHook } from "./usePermissions";

export interface OdooMigrationPermissions {
  canView: boolean;
  canExecuteManual: boolean;
  canViewLogs: boolean;
  canConfigure: boolean;
  canCancel: boolean;
  canViewHistory: boolean;
  isLoading: boolean;
}

/**
 * Hook de permisos para Odoo Migration
 * Ahora delega al hook centralizado para eliminar lógica duplicada
 */
export function useOdooMigrationPermissions(): OdooMigrationPermissions {
  const result = usePermissionsHook();

  return {
    canView: result["canView"] || false,
    canExecuteManual: result["canExecuteManual"] || false,
    canViewLogs: result["canViewLogs"] || false,
    canConfigure: result["canConfigure"] || false,
    canCancel: result["canCancel"] || false,
    canViewHistory: result["canViewHistory"] || false,
    isLoading: result.isLoading,
  };
}
